// prettier-ignore
export const priorityEnum = [
  { id: 'LOW', label: 'Nízká' },
  { id: 'MEDIUM', label: 'Střední' },
  { id: 'HIGH', label: 'Vysoká' }
];



// WEBPACK FOOTER //
// ./src/modules/tasks/_tasksEnums.ts